import { render } from "./graficheTitlesTab.vue?vue&type=template&id=172b903f&scoped=true"
import script from "./graficheTitlesTab.vue?vue&type=script&lang=js"
export * from "./graficheTitlesTab.vue?vue&type=script&lang=js"

import "./graficheTitlesTab.vue?vue&type=style&index=0&id=172b903f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172b903f"]])

export default __exports__